<template>
  <section class="clients-partners position-relative see__pad">
    <div class="pattern-layer">
      <div class="pattern-5 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-6 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-7 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-8 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
    </div>

    <div class="header-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="clients-header text-center">
            <div class="clients-section-label">
              <h4>{{ content.header.sectionLabel }}</h4>
            </div>
            <div class="clients-main-title">
              <h2>{{ content.header.mainTitle }}</h2>
            </div>
            <div class="clients-description">
              <p>{{ content.header.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="header-container">
      <div class="clients-grid">
        <div class="client-item" v-for="(client, index) in content.clients" :key="index">
          <div class="client-logo">
            <div class="logo-placeholder">
              <span>{{ client.logoText }}</span>
            </div>
          </div>
          <div class="client-info">
            <h4>{{ client.name }}</h4>
            <p>{{ client.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutClientsComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.pattern-5 {
  bottom: 25%;
  right: 20%;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-6 {
  top: 40%;
  left: 5%;
  width: 110px;
  height: 110px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-7 {
  bottom: 15%;
  left: 12%;
  width: 85px;
  height: 85px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-8 {
  top: 35%;
  right: 8%;
  width: 95px;
  height: 95px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

/* Clients & Partners Section */
.clients-partners {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.clients-header {
  position: relative;
  z-index: 2;
  margin-bottom: 60px;
}

.clients-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.clients-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.clients-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

.clients-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.client-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 30px;
  text-align: center;
  transition: all 0.3s ease;
}

.client-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(246, 236, 79, 0.2);
  border-color: #F6EC4F;
}

.client-logo {
  margin-bottom: 20px;
}

.logo-placeholder {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  color: #00061A;
  font-weight: 700;
  font-size: 12px;
  text-align: center;
}

.client-info h4 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
  font-family: 'Archivo', sans-serif;
}

.client-info p {
  font-size: 14px;
  color: #F6EC4F;
  margin: 0;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .clients-partners {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .clients-partners {
    padding: 60px 0;
  }
  
  .clients-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .clients-section-label h4 {
    letter-spacing: 8px;
    font-size: 16px;
  }
  
  .clients-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 20px;
  }
}

@media only screen and (max-width: 399px) {
  .clients-partners {
    padding: 40px 0;
  }
  
  .clients-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
}
</style>
